"use client";
import Image from "next/image";
import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);

  // Toggle the Read More state
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  // rohailjohn
  return (
    <>
      <div
        className={`${isReadMore ? "line-clamp-5" : ""} overflow-hidden`}
        style={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
        }}
      >
        {/* {text} */}
        <p
          dangerouslySetInnerHTML={{ __html: text }}
          className="updatedparapremu pt-6"
        ></p>
      </div>
      {text.length > 380 && (
        <div
          onClick={toggleReadMore}
          className="style-redmore"
          style={{
            color: "#D5AF34",
            fontSize: "17px",
            display: "inline-block",
            marginLeft: "1px",
            cursor: "pointer",
          }}
        >
          {isReadMore ? "Read More" : "Show less"}
        </div>
      )}
    </>
  );
};
function airport({ Mydata }) {
  const data = Mydata[3];
  return (
    <div>
      <div className="mx-auto max-w-7xl  mb-7">
        <div className="text-center px-6">
          <h2 className="text-3xl secondary font-bold">
            {data.title}
            <span className="text-[#D5AF34]">{data.subtitle}</span>
          </h2>
          <p className="updatedparapremu pt-4 pb-4">{data?.desc}</p>
        </div>
        <div className="grid      grid-cols-1 sm:grid-cols-1 md:grid-cols-1   lg:grid-cols-2 gap-9 px-6">
          {data.slider.map((items, index) => {
            return (
              <>
                <div key={index} className="rounded-2xl slie p-4">
                  <div>
                    <Image
                      src={items.image}
                      height={170}
                      width={700}
                      alt={items.alt}
                      title={items.alt}
                      loading="lazy"
                      className="mb-3"
                    />
                  </div>
                  <h2 className="updatedheading mb-3">{items.title}</h2>
                  <div className="updatedparapremu">
                    <ReadMore maxLines={5}>{items.des}</ReadMore>
                  </div>
                </div>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default airport;
